import { render, staticRenderFns } from "./LogsList.vue?vue&type=template&id=6b4e2981&scoped=true&"
import script from "./LogsList.vue?vue&type=script&lang=js&"
export * from "./LogsList.vue?vue&type=script&lang=js&"
import style0 from "./LogsList.vue?vue&type=style&index=0&id=6b4e2981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e2981",
  null
  
)

export default component.exports